{
  "name": "ccfx-ws-backoffice",
  "version": "1.21.12",
  "scripts": {
    "ng": "ng",
    "start": "node scripts/dev.mjs",
    "start:ng": "ng serve",
    "generate:search-index": "node scripts/generate-global-search-index.mjs",
    "watch:search-index": "node scripts/generate-global-search-index.mjs --watch",
    "prebuild": "npm run generate:search-index",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "vitest run",
    "test:watch": "vitest"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.2",
  "dependencies": {
    "@angular/animations": "~21.2.5",
    "@angular/cdk": "~21.2.3",
    "@angular/common": "~21.2.5",
    "@angular/compiler": "~21.2.5",
    "@angular/core": "~21.2.5",
    "@angular/forms": "~21.2.5",
    "@angular/material": "~21.2.4",
    "@angular/platform-browser": "~21.2.5",
    "@angular/router": "~21.2.5",
    "@azure/msal-angular": "^5.0.3",
    "@azure/msal-browser": "^5.1.0",
    "@ccfx/shared-lib": "npm:@continentalcurrencyexchange/shared-lib@^1.2.9",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@jsverse/transloco": "^8.2.1",
    "@microsoft/signalr": "^10.0.0",
    "@ngrx/signals": "^21.0.1",
    "ag-grid-angular": "~35.2.0",
    "ag-grid-enterprise": "~35.2.0",
    "currency-to-country": "^0.1.2",
    "exceljs": "^4.4.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^13.0.0",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.2.3",
    "@analogjs/vitest-angular": "^2.2.3",
    "@angular-devkit/build-angular": "~21.2.3",
    "@angular/build": "~21.2.3",
    "@angular/cli": "~21.2.3",
    "@angular/compiler-cli": "~21.2.5",
    "@angular/material": "~21.2.4",
    "@angular/platform-browser-dynamic": "~21.2.5",
    "@types/node": "^22.20.3",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
